import { Box, Divider, TableCell, TableRow } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import React from 'react';
import { colors } from 'theme';

const useStyles = makeStyles(theme => ({
  separatorRow: {
    padding: '0 0 12px 0',
  },
  separatorCell: {
    padding: '12px 0',
    borderBottom: (props: { leftWidthPercent: number; withoutBottomBorder: boolean }) =>
      props.withoutBottomBorder ? 'none' : 'inherit',

    '&.MuiTableCell-sizeSmall': {
      padding: 0,
    },
  },
  tableDivider: {
    width: '100%',
    height: 1,
    marginTop: 'auto',
    marginBottom: 'auto',
    borderBottom: 'none',
  },
  blueTableDivider: {
    color: colors.primary,
    backgroundColor: theme.palette.primary.main,
  },
  greyTableDivider: {
    color: colors.greyBlue,
  },
  redTableDivider: {
    color: colors.red,
    backgroundColor: colors.red,
  },
  tableDividerLeft: {
    width: (props: { leftWidthPercent: number; withoutBottomBorder: boolean }) => `${props.leftWidthPercent}%`,
    marginLeft: 0,
    marginRight: 12,
  },
  tableDividerRight: {
    width: 'auto',
    flexGrow: 1,
    marginLeft: 12,
    marginRight: 0,
  },
}));

interface TableSeparatorRowProps {
  leftWidthPercent?: number;
  withoutBottomBorder?: boolean;
  greyColorScheme?: boolean;
  isError?: boolean;
}

const TableSeparatorRow: React.FC<TableSeparatorRowProps> = ({
  children,
  leftWidthPercent = 12,
  withoutBottomBorder = false,
  greyColorScheme = false,
  isError = false,
}) => {
  const classes = useStyles({ leftWidthPercent, withoutBottomBorder });
  const color = isError ? colors.red : greyColorScheme ? colors.greyBlue : 'primary.main';

  const tableDividerTheme = isError
    ? classes.redTableDivider
    : greyColorScheme
    ? classes.greyTableDivider
    : classes.blueTableDivider;

  return (
    <TableRow className={classes.separatorRow}>
      <TableCell colSpan={99} className={classes.separatorCell}>
        {children ? (
          <Box display="flex" color={color} fontWeight={600}>
            <Divider className={classNames(classes.tableDivider, tableDividerTheme, classes.tableDividerLeft)} />
            {children}
            <Divider className={classNames(classes.tableDivider, tableDividerTheme, classes.tableDividerRight)} />
          </Box>
        ) : (
          <Divider className={classNames(classes.tableDivider, tableDividerTheme)} />
        )}
      </TableCell>
    </TableRow>
  );
};

export default TableSeparatorRow;
